import { Button } from "components/core/button"
import { Modal } from "components/core/modal/modal"
import { CustomWidgetModal } from "components/dashboard/widgets/customWidgets/customWidgetModal"
import React, { FC, useState } from "react"
import { Widget } from "domainModels/widget"
import { WidgetLayout } from "components/dashboard/widgets/shared/widgetLayout"
import { widgetMatchesSearch } from "components/dashboard/grid/helpers"
import { useUiContext } from "components/providers/uiProvider"
import { useCurrentDashboard, useIsDashboardOwner } from "reactQuery/dashboard"
import { useDeleteWidget } from "reactQuery/widget"

interface Props {
  widget: Widget
}

export const ExternalUrlWidget: FC<Props> = ({ widget }) => {
  const [showModal, setShowModal] = useState(false)
  const { data: dashboard } = useCurrentDashboard()
  const { mutateAsync: deleteWidget } = useDeleteWidget()
  const { value } = useUiContext()
  const { searchQuery } = value
  const isDashboardOwner = useIsDashboardOwner()
  const isBlurred =
    searchQuery.length > 0 &&
    !widgetMatchesSearch({ name: widget.information.name, keywords: widget.information.keywords, searchQuery }) &&
    !widget.information.markdown?.toLowerCase().includes(searchQuery)

  const onRemove = async () => {
    if (widget && dashboard?.id) {
      await deleteWidget({ widget, dashboardId: dashboard.id })
    }
  }

  return (
    <WidgetLayout
      layout={widget.layout}
      isLocked={widget.layout?.xxl.static}
      isBlurred={isBlurred}
      isDashboardOwner={isDashboardOwner}
      onRemove={onRemove}
    >
      <div className="h-full w-full flex items-center justify-center">
        <Button
          onClick={() => setShowModal(true)}
          variant="naked"
          className="z-10 text-base !text-gray-700 dark:!text-gray-300 hover:scale-105"
        >
          {widget.information.name}
        </Button>
      </div>

      <Modal show={showModal} className="max-w-[90vw]" onClose={() => setShowModal(false)}>
        <CustomWidgetModal widget={widget} />
      </Modal>
    </WidgetLayout>
  )
}
